import PhysicianForm from './PhysicianForm';

export default PhysicianForm;
